import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router";
import bookOverview from '../../../types/BookOverviewType';
import IsbnType from '../../../types/IsbnType';
import Button from '../../01_atoms/Button/Button';
import DeleteButton from '../../01_atoms/DeleteButton/DeleteButton';
import Subtitle from '../../01_atoms/Subtitle/Subtitle';
import Header from '../../02_molecules/Header/Header';
import IsbnSearch from '../../02_molecules/IsbnSearch/IsbnSearch';
import AddBookForm from '../../03_organisms/AddBookForm/AddBookForm';
import PopUpViewDelete from '../../03_organisms/PopUpViewDelete/PopUpViewDelete';

function adminEditBookTemplate() {
  const location = useLocation();
  const data = location.state as bookOverview;
  const subtitle = `Bewerk ${data.title}`;

  // ISBN
  const [isbnData, setIsbnData] = useState<IsbnType>();
  const [isbn, setIsbn] = useState('');

  // Delete
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [id, setId] = useState('');
  const [showPopUp, setShowPopUp] = useState(false);

  useEffect(() => {
    window.addEventListener('deleteClicked', (e) => {
      setTitle((e as CustomEvent).detail.title);
      setAuthor((e as CustomEvent).detail.author);
      setId((e as CustomEvent).detail.id);

      setShowPopUp(!showPopUp);
    });

    if (data.isbn) setIsbn(data.isbn.toString());
    return () => {
      // Remove event listeners
      window.removeEventListener('deleteClicked', (e) => {
        setTitle((e as CustomEvent).detail.title);
        setAuthor((e as CustomEvent).detail.author);
        setId((e as CustomEvent).detail.id);
      });
    };
  }, [showPopUp]);
  return (
    <div>
      {showPopUp ? (
        <PopUpViewDelete title={title} auteur={author} id={id} setShowPopUp={setShowPopUp} />
      ) : null}
      <header>
        <Header title="Sweet Bibi - Admin" />
      </header>
      <Subtitle title={subtitle} />
      <div className="t-admin-edit-book__isbn-container">
        <IsbnSearch setData={setIsbnData} setIsbnNumber={setIsbn} isbnValue={isbn} />
      </div>
      <AddBookForm isbnData={isbnData} bookData={data} isbnNumber={isbn} editForm />
      <div className="t-admin-edit-book__submit">
        <DeleteButton id={data.id} title={data.title} author={data.author} />
        <div className="t-admin-edit-book__container">
          <Button
            label="Boek Bewerken"
            type="primary"
            submit
            submitForm="add-book-form"
            setClicked={() => ''}
          />
          <Button
            label="Annuleren"
            type="secondary"
            setClicked={() => {
              window.location.href = '../admin';
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default adminEditBookTemplate;

